import { render, staticRenderFns } from "./CustomerGroup.vue?vue&type=template&id=b89398a6&scoped=true"
import script from "./CustomerGroup.vue?vue&type=script&lang=js"
export * from "./CustomerGroup.vue?vue&type=script&lang=js"
import style0 from "./CustomerGroup.vue?vue&type=style&index=0&id=b89398a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89398a6",
  null
  
)

export default component.exports